<template>
<main role="main">
 <section class="banner">
        <!-- wrap-->
   <div class="container">
    <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
    <div id="notfound">
      <div class="notfound">
       <div class="notfound-403">
        <h1>Oops!</h1>
        <h2>403 - Looks like you're not authorized to access this page</h2>
       </div>
       <p>
        Back to <router-link title="Navigate to the home page" :to="{name: 'home'}" v-b-tooltip.hover.bottom>Home page</router-link>
       </p>
      </div>
     </div>
    </div>
  </div>
</section>
</main>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'NoAccess.vue',
  created() {
    if(!this.userFromComputed())
     this.$router.push('/login');
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  },
  methods: {
      userFromComputed() {
          return this.authenticatedUser;
      },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NoAccess.vue